// extracted by mini-css-extract-plugin
export default {"root":"InviteUserForm_root__5QkbV","form":"InviteUserForm_form__9feD1","after":"InviteUserForm_after__9dJWA","avatarIcon":"InviteUserForm_avatarIcon__-tZRU"};